import React from 'react';
import { Tab, Tabs } from '@mui/material';

const View: React.FC<{
  onChangeTab: (_: React.SyntheticEvent, newTab: number) => void;
  labels: string[];
  current: number;
  scrollButtons?: 'auto' | true | false;
  variant?: 'standard' | 'scrollable' | 'fullWidth';
  sx?: Record<string, React.CSSProperties>;
}> = ({ onChangeTab, labels, current, sx, scrollButtons, variant }) => {
  return (
    <Tabs
      sx={{ padding: 0, ...sx }}
      value={current}
      onChange={onChangeTab}
      variant={variant || 'standard'}
      scrollButtons={scrollButtons || false}
    >
      {labels.map((label, index) => (
        <Tab
          data-cy={`Tabs_${index}`}
          key={label}
          sx={{ padding: 0 }}
          label={label}
        />
      ))}
    </Tabs>
  );
};

export default View;
